<template>
    <p>Página de error.</p>
</template>

<script>
export default {
    name: "Error404",
};
</script>